export default "__VITE_ASSET__decc2979__"